import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {FetchBillRequest} from './fetch-bill-request';
import {InitiateTransaction} from './initiate-transaction';
import {TamabillLandportRequest} from './tamabil-landport/tamabil-landport-req';
import {SavarMunicipilityInitiateReq} from './savar-municiplility/savar-municipility-initiate-req';
import {RaiseComplaintReq} from './raise-complaint/raiseComplaintReq';
import {FeedbackRequest} from './support/feedback-request';
import {UserComplaintRequest} from './user-complaint-status/user-complaint-req';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class PaymentService {
  constructor(public http: HttpClient) {
  }

  // paymentUrl = 'https://ekpay.gov.bd';
  // paymentUrl = 'http://localhost:8080';
  // paymentUrl = 'https://sandbox.ekpay.gov.bd';
  paymentUrl = '';

  getBannerImage(): any {
    return this.http.post('/patron/access/banners', {observe: 'response'});
  }

  fetchServices(): any {
    return this.http.get('/patron/access/services/billers?id=ALL&mode=web', {observe: 'response'});
  }
  fetchEducationalInstitutes(): any {
    return this.http.get('/patron/access/services/biller/educational-institute', {observe: 'response'});
  }
  fetchApplicationTypes(): Observable<any> {
    return this.http.get('/patron/access/services/biller/dscc/application-type', {observe: 'body'});
  }

  fetchBill(fetchbillreq: FetchBillRequest): any {
    const fetch_json = JSON.stringify(fetchbillreq);
    return this.http.post('/patron/access/fetch-bill', fetch_json, {observe: 'response'});
  }

  initiatePayment(init: InitiateTransaction): any {
    const fetch_json = JSON.stringify(init);
    return this.http.post(this.paymentUrl + '/paymentprocessor/api/initiate/payment', fetch_json, {observe: 'response'});
  }

  paymentReq(status: string, id: string): any {
    return this.http.post(this.paymentUrl + '/paymentprocessor/api/paystatus/success/w/?status=' + status + '&transId=' + id, {observe: 'response'});
  }

  paymentReqFail(status: string, id: string): any {
    return this.http.post(this.paymentUrl + '/paymentprocessor/api/paystatus/fail/w/?status=' + status + '&transId=' + id, {observe: 'response'});
  }

  paymentReqCancel(status: string, id: string): any {
    return this.http.post(this.paymentUrl + '/paymentprocessor/api/paystatus/cancel/w/?status=' + status + '&transId=' + id, {observe: 'response'});
  }

  loadReviewlist(): any {
    return this.http.get('/patron/api/review/list', {observe: 'response'});
  }

  initiateTamaBillLandPort(tamabillReq: TamabillLandportRequest): any {
    return this.http.post('/patron/access/offline-biller/landport-authority-form/save', tamabillReq, {observe: 'response'});
  }

  initiateSavarMunicipility(savarIniti: SavarMunicipilityInitiateReq): any {
    return this.http.post('/patron/access/offline-biller/municipality-form/save', savarIniti, {observe: 'response'});
  }

  raiseComplaint(raiseComplain: RaiseComplaintReq): any {
    return this.http.post('/patron/complaint/raise', JSON.stringify(raiseComplain), {observe: 'response'});
  }

  submitFeedback(feedbackReq: FeedbackRequest): any {
    return this.http.post('/patron/complaint/feedback', JSON.stringify(feedbackReq), {observe: 'response'});
  }

  getComplaintByEkpayId(userComplaintReq: UserComplaintRequest): any {
    return this.http.post('/patron/complaint/history', JSON.stringify(userComplaintReq), {observe: 'response'});
  }

  getOperatorOffers(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get('/patron/api/top-up/operator/get-operator-offers', options);
  }

  getOperators(): any {
    return this.http.get('/patron/api/top-up/operator/get');
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/Payment.Services.ts